module.exports = __webpack_public_path__ + "static/media/kredyt_10.6270b3c7.png";